export const iconFontAwesomeWeatherCloudMoonRain = (
	<i className="fa-solid fa-cloud-moon-rain"></i>
);
